<template>
  <b-form-group
    label="Gider Tanımı"
    label-for="title"
  >
    <v-select
      v-model="dataItem.id_donation_groups"
      :options="donationGroups"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
      @input="getDonationGroup"
    >
      <template v-slot:option="option">
        <div class="font-weight-bold">
          {{ option.title }}
        </div>
        <div class="font-small-2 text-muted">
          {{ option.main_group }}
        </div>
        <b-badge
          class="font-small-2"
          :variant="option.id_account_types === '1'? 'light-success' : 'light-danger'"
        >
          {{ option.account_type }}
        </b-badge>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'DonationGroups',
  components: {
    BFormGroup,
    BBadge,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    donationGroups() {
      return this.$store.getters['donationGroups/dataList']
    },
  },
  created() {
    this.getDonationGroups()
  },
  methods: {
    getDonationGroup() {
      if (this.dataItem.id_donation_groups) {
        this.$store.dispatch('donationGroups/getDataItem', this.dataItem.id_donation_groups)
          .then(response => {
            this.dataItem.donation_group = response.title
            this.dataItem.donation_type = response.donation_type
            this.dataItem.main_group = response.donation_group
            this.dataItem.account_type = response.account_type
            this.dataItem.id_donation_types = response.id_donation_types
            this.dataItem.id_account_types = response.id_account_types
          })
      }
    },
    getDonationGroups() {
      this.$store.dispatch('donationGroups/getDataList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
          'main_group.title AS main_group',
          'account_types.title AS account_type',
          'donation_groups.id_account_types AS id_account_types',
          'donation_groups.id_donation_types AS id_donation_types',
        ],
        where: {
          'donation_groups.id_donation_groups !=': null,
          'donation_groups.is_expense': 1,
        },
      })
    },
  },
}
</script>
